export default {"src":"/newStatic/_next/static/media/user.712954f7.svg","height":29,"width":30};